const handleMaintenanceStatusModal = {
  text1: '¿Realmente desea',
  text2: 'este Mantenimiento?',
  confirm_title: 'MANTENIMIENTO',
  cancel: 'CANCELAR',
  send: 'ENVIAR',
  complete: 'CONCLUIR',
  reactivate: 'REACTIVAR'
};

export default handleMaintenanceStatusModal;